export const SET_NATIONALITIES = 'SET_NATIONALITIES';
export const SET_INDUSTRIES = 'SET_INDUSTRIES';
export const SET_OCCUPATIONS = 'SET_OCCUPATIONS';
